import React from 'react';

const InvoiceListItemAvatarAdult = ({src}) => (
  <div className='flex-shrink-0'>
    <img className='h-12 w-12 rounded-full' src={src} alt={src} />
  </div>
);

export default InvoiceListItemAvatarAdult;
